module.exports = __webpack_public_path__ + "media/images/city_img/s-8bdcbeab051ad1e0ff28bacee9fdc922.jpg";